export default __webpack_public_path__ + "static/videoclap-46531581277527559381948f237fd8f4.jpg";